import Styles from '../../../ArticlesComponents/ArticleWrapper/styles.module.scss';

export default function IndexesList(props) {
  const { articles } = props;
  return (
    <section className={Styles['indexes-list']}>
      {Object.entries(articles).map((pair) => (
        <a key={pair[0]} href={`#${pair[0]}`}>{pair[1]}</a>
      ))}
    </section>
  );
}
